import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["transition"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useRef, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { applyParentSelector, stringifyStyles } from './AnimatedSelector.utils';
import { StylePropType } from '../../../../services/proptypes';
import { classNames } from '../../../../utils/classname';
import { DEFAULT_ANIMATION_DURATION } from '../../animation.constants';
import useAnimation from '../../hooks/use-animation';
import { getStylesForTransitionProps, getTransition, getPropertyNameForTransitionType } from '../../services/animation';
import { Transition, TransitionProps, AnimationStatusPropType } from '../../types/animation.types';
import { AnimationRunPolicyPropType } from '../../types/run-policy.types';
var defaultProps = {
  duration: DEFAULT_ANIMATION_DURATION,
  transitionProps: {},
  status: undefined,
  easing: 'ease',
  className: '',
  style: {},
  animationKey: undefined,
  runPolicy: undefined
};
export default function AnimatedSelector(_ref) {
  var _classNames;
  var className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    transitionType = _ref.transitionType,
    statusProp = _ref.status,
    duration = _ref.duration,
    transitionProps = _ref.transitionProps,
    easing = _ref.easing,
    targetSelector = _ref.targetSelector,
    animationKey = _ref.animationKey,
    runPolicy = _ref.runPolicy;
  var _useRef = useRef(statusProp !== undefined),
    isControlled = _useRef.current;
  var randomClassNameRef = useRef(null);
  if (randomClassNameRef.current === null) {
    randomClassNameRef.current = uuidv4();
  }
  if (!children) {
    return null;
  }
  if (!transitionType) {
    return children;
  }
  var _useAnimation = useAnimation([transitionType], {
      duration: duration,
      animationKey: animationKey,
      runPolicy: runPolicy
    }),
    isReady = _useAnimation.isReady,
    state = _useAnimation.state,
    startAnimation = _useAnimation.startAnimation;
  var statusDerived = isControlled ? statusProp : state.status;
  useEffect(function () {
    if (!isControlled) {
      // if uncontrolled animation is triggered when mounted
      if (isReady) {
        startAnimation();
      }
    }
  }, [isReady]);
  var randomclassName = randomClassNameRef.current;
  var mainClassName = "animated-selector--".concat(randomclassName);
  var baseClassName = classNames((_classNames = {}, _defineProperty(_classNames, mainClassName, true), _defineProperty(_classNames, transitionType, true), _defineProperty(_classNames, statusDerived, true), _defineProperty(_classNames, className, true), _classNames));
  var cssAnimatedselectors = applyParentSelector(mainClassName, targetSelector);
  var propertyName = getPropertyNameForTransitionType(transitionType);
  var transition = getTransition(duration, easing, propertyName);
  var _getStylesForTransiti = getStylesForTransitionProps(transitionType, statusDerived, transitionProps || {}, state.prevStatus),
    styleTransition = _getStylesForTransiti.transition,
    restOfTransitionStyles = _objectWithoutProperties(_getStylesForTransiti, _excluded);
  var parentStyles = _objectSpread(_objectSpread({
    transition: styleTransition || transition
  }, restOfTransitionStyles), {}, {
    WebkitTransition: transition
  });
  var stringifiedStyles = stringifyStyles(parentStyles, {
    useImportant: true
  });
  return /*#__PURE__*/React.createElement("div", {
    className: baseClassName,
    style: style
  }, /*#__PURE__*/React.createElement("style", null, "\n          ".concat(cssAnimatedselectors, " { ").concat(stringifiedStyles, " }\n        ")), children);
}
AnimatedSelector.defaultProps = defaultProps;